import { AddCartItemParams, CartAutoReload } from 'smg/customer-api/carts';
import { Quotes } from 'smg/customer-api/quotes';
import { ShowError } from 'smg/errors';
import QueryString from 'smg/querystring';

import * as carts from '../carts';

// LoadCartFromQuery inspects the URL for ?quote, ?order, ?instance, or ?cart
// and seeds the cart from whichever is present. When none are present it
// simply leaves the existing cart alone. It returns the cart poller, which
// reloads the page when the cart changes; completing the order stops it.
export async function LoadCartFromQuery(): Promise<AbortController> {
    const q = QueryString();
    const quoteID = q.get('quote');
    const orderID = q.get('order');
    const quoteSentInstanceID = q.get('instance');
    const cartID = q.get('cart');

    if (quoteID) {
        await carts.AddCartItem({ quoteID }, newCartOpts).catch(ShowError);
    } else if (orderID) {
        await carts.AddCartItem({ orderID }, newCartOpts).catch(ShowError);
    } else if (quoteSentInstanceID) {
        await loadCartFromQuoteSentInstance(quoteSentInstanceID);
    } else if (cartID) {
        await carts.AddCartItem({ cartID }, newCartOpts).catch(ShowError);
    }

    return CartAutoReload();
}

const newCartOpts = {
    promptToCheckout: false,
    hideCartLink: true,
    showToast: false,
    newCart: true,
};

async function loadCartFromQuoteSentInstance(instance: string): Promise<void> {
    const q = instance.length === 43 ? `quoteSentKey:${instance}` : `quoteSentInstanceID:${instance}`;

    try {
        const data = await Quotes({
            sort: 'serial desc',
            max: 100,
            data: 'serial,created,quoteLineItems,quoteProofs,cachedTotal,quoteOrders,quoteRequest,key',
            q,
        });
        const quotes: AddCartItemParams[] = data.quotes.map(quote => ({ quoteID: quote.key }));
        await carts.AddCartItem(quotes, newCartOpts);
    } catch (err) {
        ShowError(err);
    }
}
